import './sleep.css';
import React, {useRef, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import Routes from "../../assets/RoutesToPages/Routes";
import {ReactComponent as SleepMainLogo} from './img-sleep/main-img.svg';
import {ReactComponent as SleepRelaxationLogo} from './img-sleep/avocadoes/avocado-relaxation.svg';
import {ReactComponent as BetterSleepLogo} from './img-sleep/avocadoes/avocado-sleep.svg';


const SleepPage = () => {
  const navigate = useNavigate();
  const SleepPageContainerRef = useRef(null);
  const timerFadeIn = useRef(null);


  useEffect(() => {
    if (SleepPageContainerRef.current) {
      SleepPageContainerRef.current.classList.add('sleep-page-container-fade-in');
    }

    timerFadeIn.current = setTimeout(() => {
      SleepPageContainerRef.current.classList.remove('sleep-page-container-fade-in');
    }, 350)

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);


  const handleChooseTips = (pageIdentifier) => () => {
    navigate(Routes.sleepTipsPage, {
      state: {
        pageID: pageIdentifier,
      }
    });
  }

  return (
    <div ref={SleepPageContainerRef}
         className='sleep-container'>
      <p className='sleep-container__title'>Sleep</p>
      <div className='sleep-content'>
        <SleepMainLogo className="sleep-content-logo"
                       width='158'
                       height='149'/>
        <div className='sleep-navigation'>
          <img className='sleep-navigation__arrow'
               onClick={() => navigate(Routes.mainPage)}
               loading="lazy"
               src={require("./img-sleep/back_arrow.svg").default}
               width='24'
               height='24'
               alt="image arrow left">
          </img>
        </div>
        <div className='sleep-tips-container-start'>
          <div className="sleep-tips-recommendation">
            <img className='sleep-tips-recommendation__img'
                 loading="lazy"
                 src={require('./img-sleep/stay-healthy-img.png')}
                 width={18}
                 height={18}
                 alt="image hand with muscle"/>
            <div className="sleep-tips-recommendation__description">
              <p className='description-tip'>To stay healthy and energized, it’s necessary
                to get enough sleep every night.</p>
              <p className='description-check'>Check out our tips how to do it right!</p>
            </div>
          </div>

          <div className="sleep-tips-categories">
            <div className="physical-relaxation-category"
                 onClick={handleChooseTips('physical-relaxation')}>
              <div className="img-category-container">
                <SleepRelaxationLogo className='img-category-relaxation'
                                     width={80}
                                     height={61}/>
              </div>
              <div className="relaxation-description-container">
                <h1 className='relaxation-title'>Tips for Physical Relaxation</h1>
                <p className='relaxation-description'>Tried-and-true tips for
                  creating a restful environment while sleeping.</p>
              </div>
            </div>

            <div className="better-sleep-category"
                 onClick={handleChooseTips('better-sleep')}>
              <div className="img-category-container">
                <BetterSleepLogo className='img-category-sleep'
                                 width={43}
                                 height={75}/>
              </div>
              <div className="sleep-description-container">
                <h1 className='sleep-title'>Tips for Better Sleep</h1>
                <p className='sleep-description'>Suggestions for getting a
                  good night's sleep.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SleepPage;